import { cfImageUrl as build, type ImageVariant } from '@viet-parenting/supabase/cf-images';

const HASH = import.meta.env.VITE_CF_IMAGES_ACCOUNT_HASH;

/** Admin wrapper that pre-binds the account hash, mirroring apps/web. */
export function cfImageUrl(imageId: string, variant: ImageVariant = 'public'): string {
  return build(imageId, HASH, variant);
}

export type { ImageVariant };
